import { render, staticRenderFns } from "./ReceptionTab.vue?vue&type=template&id=6addf51c&scoped=true&"
import script from "./ReceptionTab.vue?vue&type=script&lang=ts&"
export * from "./ReceptionTab.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionTab.vue?vue&type=style&index=0&id=6addf51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6addf51c",
  null
  
)

export default component.exports